/* eslint-disable */
/**
 * The path of the `DocketsPage` to be consumed by a `<Router />`
 * @export
 */
export const DOCKETS_PAGE_PATH = `/dockets`;

/**
 * Create a `href` that will resolve to `DocketsPage`
 * @export
 * @returns {string} The `DOCKETS_PAGE_PATH`
 */
export const createDocketsPageLink = () => DOCKETS_PAGE_PATH;

/**
 * Determine if the current page is the `DocketsPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `DocketsPage`
 */
export const isDocketsPage = (match) => match.path === DOCKETS_PAGE_PATH;
